import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownRendererProps {
  content: string;
  className?: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content, className = '' }) => {
  const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
  // Ensure we have a proper base URL without a trailing slash
  const baseUrl = apiBase.replace(/\/api\/?$/, '');

  return (
    <div className={`prose dark:prose-invert max-w-none ${className}`}>
      <ReactMarkdown 
        remarkPlugins={[remarkGfm]}
        components={{
          img: ({ node, ...props }) => {
            let src = props.src;
            // Handle different image source formats
            if (src) {
              if (src.startsWith('/uploads') || src.startsWith('/api/uploads')) {
                // Prepend base URL to relative paths
                // If src already starts with /api/uploads, and baseUrl is e.g. https://api.com
                // then src becomes https://api.com/api/uploads/...
                // If src starts with /uploads, it becomes https://api.com/uploads/...
                src = `${baseUrl}${src}`;
              } else if (src.includes('/uploads/') && src.includes('localhost:')) {
                // Replace localhost URL with the current backend URL if it's an old-style absolute URL
                const parts = src.split('/uploads/');
                src = `${baseUrl}/uploads/${parts[1]}`;
              }
            }
            return (
              <img 
                {...props} 
                src={src} 
                className="rounded-lg shadow-sm max-w-full my-4 border border-gray-200 dark:border-gray-700" 
                alt={props.alt || 'Uploaded image'} 
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.onerror = null; // prevent infinite loop
                  console.error('Image failed to load:', src);
                }}
              />
            );
          }
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
